<div style="display:flex; flex: 1 1 0;">
  <kendo-textbox [hidden]="selectedType !== 'Standard'"
    #standard class="k-textbox" style="width:100%;" [(ngModel)]="standardValue" />

  <kendo-multiselect [hidden]="selectedType !== 'Multiselect'"
    (valueChange)="onChange($event)"
    [data]="data()"
    [(ngModel)]="value"
    [valuePrimitive]="true">
  </kendo-multiselect>

  <kendo-dropdownlist
    class="k-dropdown-operator"
    title="Filter"
    [value]="selectedType"
    (valueChange)="filterTypeChange($event)"
    [popupSettings]="{
      width: 80
    }"
    [data]="types" style="margin-left: 4px; font-size:14px; height: 30px;">
  </kendo-dropdownlist>

  @if (hasFilterValue && selectedType === 'Standard') {
    <button type="button" kendoButton title="Clear" [svgIcon]="icons.filterClear" (click)="clearFilter()" class="k-button" style="margin-left: 4px; padding: 6px; border-radius: 0px !important; height: 30px;"></button>
  }
</div>